import React, { Suspense } from "react";
import { useLocation } from "react-router-dom";
import AddItemProductForCostingForm from "./AddItemProductForCostingForm";

const AddItemProductCostingPage = () => {
  const location = useLocation();
  console.log("AddItemProductCostingPage_location.state", location.state);
  var action = "Add";
  var costingSheet = {
    productTitle: "",
    code: "",
    productDetail: "",
  };
  if (location.state !== null && location.state !== undefined) {
    action = "Edit";
    costingSheet = location.state.costingSheet;
  }

  const containerStyle = {
    maxWidth: "900px",
    margin: "15px auto",
    padding: "15px 30px",
    backgroundColor: "rgb(123 47 247 / 51%)",
    // backgroundColor: "#ffffff",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    borderRadius: "12px",
    fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
  };
  return (
    <Suspense fallback={<>Loading...</>}>
      <div className="main_container px-5" style={containerStyle}>
        <div className="right_col" role="main">
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="x_panel">
                <div className="x_title">
                  <div className="clearfix">
                    <h5>{action} Item Product for Costing</h5>
                  </div>
                </div>
                <div className="x_content">
                  <AddItemProductForCostingForm
                    costingSheet={costingSheet}
                    action={action}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Suspense>
  );
};
export default AddItemProductCostingPage;
